import { gql, TypedDocumentNode } from '@apollo/client';

import { SeoPageMetaContent, SeoPageType } from '@pflegia/types/common/seo-page-meta/seo-page-meta';

export type SeoPageMetaProp = SeoPageMetaContent & { path: string };

export const GET_SEO_PAGE_META: TypedDocumentNode<{ seoPageMeta: SeoPageMetaContent | null }, { pageType: SeoPageType; path: string }> =
  gql`
    query SeoPageMeta($pageType: String!, $path: String!) {
      seoPageMeta: resolvedSeoPageMeta(pageType: $pageType, path: $path) {
        title
        description
        h1
      }
    }
  `;
